import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- master Inventory Apis ------------------------------
export const getCustomers = createAsyncThunk(
    "getCustomers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getCustomers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getInvoiceItemList = createAsyncThunk(
    "getInvoiceItemList",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getInvoiceItemList, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const addInvoice = createAsyncThunk(
    "addInvoice",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addInvoice, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateInvoice = createAsyncThunk(
    "updateInvoice",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateInvoice, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getInvoices = createAsyncThunk(
    "getInvoices",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getInvoices, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getInvoiceById = createAsyncThunk(
    "getInvoiceById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getInvoiceById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getInvoiceItemById = createAsyncThunk(
    "getInvoiceItemById",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getInvoiceItemById, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);